"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var HomepageController =
/*#__PURE__*/
function () {
  function HomepageController() {
    _classCallCheck(this, HomepageController);

    /* Options */
    //this.API_URL = 'https://salespromo.cz/canon/bts-2020/create';
    this.API_URL = 'https://creativenow.cz/projekty/canon/2011-vanocni-prani/create';
    this.UPLOAD_SECTION_ACTIVE = true;
    this.MAX_FILE_SIZE = 8000; // KBs

    this.MIN_IMAGE_WIDTH = 1300; // PXs

    this.MIN_IMAGE_HEIGHT = 1300; //PXs

    this.MAX_IMAGE_WIDTH = 6000; // PXs

    this.MAX_IMAGE_HEIGHT = 6000; // PXs

    this.BODY = $("body");
    this.POPUP_OVERLAY = $("#overlay");
    this.RULES_POPUP_OPEN = $(".rules-open");
    this.RULES_POPUP_CLOSE = $("#rules-close");
    /* End options */

    this.uploadSection = $('section.upload');

    if (this.UPLOAD_SECTION_ACTIVE) {
      this.photoStep1Button = $('#photoStep1Button');
      this.photoStep2Button = $('#photoStep2Button');
      this.imageStep1Button = $('#imageStep1Button');
      this.formStep1ButtonImage = $('#formStep1ButtonImage');
      this.formStep1Button = $('#formStep1Button');
      this.formStep2Button = $('#formStep2Button');
      this.formSubmitButton = $('#send_form');
      this.step2PrevButton = $('#step2PrevButton');
      this.step3PrevButton = $('#step3PrevButton');
      this.step4PrevButton = $('#step4PrevButton');
      this.systemMessage = $('#system_message');
      this.error = '';
      this.form = {
        croppedImage: null,
        imageName: null,
        message: null,
        country: null,
        fullname: null,
        city: null,
        street: null,
        psc: null,
        sender_fullname: null,
        sender_email: null,
        privacy: false
      };
      this.scrollToUpload();
      this.stepsHandler();
      this.uploadImage();
      this.cropImage();
      this.photoStep2Button.fadeOut(0);
    } else {
      this.uploadSection.hide(0);
    }

    this.showRulesPopup();
    this.hideRulesPopup();
  }

  _createClass(HomepageController, [{
    key: "showRulesPopup",
    value: function showRulesPopup() {
      var _this2 = this;

      this.RULES_POPUP_OPEN.on("click", function (e) {
        e.preventDefault();

        _this2.BODY.addClass("lock");

        _this2.POPUP_OVERLAY.addClass("active");
      });
    }
  }, {
    key: "hideRulesPopup",
    value: function hideRulesPopup() {
      var _this3 = this;

      this.RULES_POPUP_CLOSE.on("click", function (e) {
        e.preventDefault();

        _this3.POPUP_OVERLAY.removeClass("active");

        _this3.BODY.removeClass("lock");
      });
    }
  }, {
    key: "validateEmail",
    value: function validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  }, {
    key: "scrollToUpload",
    value: function scrollToUpload() {
      var _this4 = this;

      $("button.scroll").click(function (e) {
        e.preventDefault();

        _this4.scrollToTop($(_this4.uploadSection));
      });
    }
  }, {
    key: "scrollToTop",
    value: function scrollToTop(container) {
      var _this = this;

      $([document.documentElement, document.body]).animate({
        scrollTop: $(container).offset().top
      }, 1000);
    }
  }, {
    key: "stepsHandler",
    value: function stepsHandler() {
      var _this5 = this;

      var step0 = $('#step-0');
      var photoStep1 = $('#photo-step-1');
      var photoStep2 = $('#photo-step-2');
      var imageStep1 = $('#image-step-1');
      var step3 = $('#step-3');
      var step4 = $('#step-4');

      var step0Toggle = function step0Toggle() {
        photoStep1.fadeOut(0);
        photoStep2.fadeOut(0);
        imageStep1.fadeOut(0);
        step3.fadeOut(0);
        step4.fadeOut(0);
        step0.fadeIn(300);
      };

      var photoStep1Toggle = function photoStep1Toggle() {
        step0.fadeOut(0);
        photoStep2.fadeOut(0);
        imageStep1.fadeOut(0);
        step3.fadeOut(0);
        step4.fadeOut(0);
        photoStep1.fadeIn(300);
      };

      var photoStep2Toggle = function photoStep2Toggle() {
        step0.fadeOut(0);
        photoStep1.fadeOut(0);
        imageStep1.fadeOut(0);
        step3.fadeOut(0);
        step4.fadeOut(0);
        photoStep2.fadeIn(300);
      };

      var imageStep1Toggle = function imageStep1Toggle() {
        step0.fadeOut(0);
        photoStep2.fadeOut(0);
        photoStep1.fadeOut(0);
        step3.fadeOut(0);
        step4.fadeOut(0);
        imageStep1.fadeIn(300);
      };

      var step3Toggle = function step3Toggle() {
        step0.fadeOut(0);
        photoStep2.fadeOut(0);
        photoStep1.fadeOut(0);
        imageStep1.fadeOut(300);
        step4.fadeOut(0);
        step3.fadeIn(300);
      };

      var step4Toggle = function step4Toggle() {
        step0.fadeOut(0);
        photoStep2.fadeOut(0);
        photoStep1.fadeOut(0);
        imageStep1.fadeOut(300);
        step3.fadeOut(0);
        step4.fadeIn(300);
      };

      var handler = function handler(step) {
        switch (step) {
          case 1:
            step0Toggle();
            break;

          case 2:
            photoStep1Toggle();

            _this5.scrollToTop('section.upload');

            break;

          case 3:
            photoStep2Toggle();

            _this5.scrollToTop('section.upload');

            break;

          case 4:
            imageStep1Toggle();

            _this5.scrollToTop('section.upload');

            break;

          case 5:
            step3Toggle();

            _this5.scrollToTop('section.upload');

            break;

          case 6:
            step4Toggle();

            _this5.scrollToTop('section.upload');

            break;
        }
      };
      /* Initial active step */

      /* Change to [1-6] for dev */


      handler(1);
      /* Next buttons */

      this.photoStep1Button.on("click", function () {
        handler(2);
      });
      this.photoStep2Button.on("click", function () {
        handler(3);
      });
      this.imageStep1Button.on("click", function () {
        handler(4);
      });
      this.formStep1ButtonImage.find("button").on("click", function (e) {
        var variant = $(e.currentTarget).data("variant");
        variant = "variant-" + variant + ".jpg";
        _this5.form.imageName = variant;
        handler(5);
      });
      this.formStep1Button.on('click', function (e) {
        e.preventDefault();
        handler(5);
      });
      this.formStep2Button.on('click', function (e) {
        _this5.form.message = $('#message_input').val();
        _this5.form.fullname = $('#fullname_input').val();
        _this5.form.city = $('#city_input').val();
        _this5.form.street = $('#street_input').val();
        _this5.form.psc = $('#psc_input').val();
        console.log(_this5.form);

        if (_this5.form.message !== '' && _this5.form.fullname !== '' && _this5.form.city !== '' && _this5.form.street !== '' && _this5.form.psc !== '') {
          e.preventDefault();
          _this5.error = '';

          _this5.systemMessage.removeClass('active');

          _this5.systemMessage.find('p').removeClass('error').text(_this5.error);

          handler(6);
        } else {
          _this5.scrollToTop('section.upload');

          _this5.error = 'Nebyla vyplněna všechna pole!';

          _this5.systemMessage.addClass('active');

          _this5.systemMessage.find('p').addClass('error').text(_this5.error);
        }
      });
      /* Send button */

      this.formSubmitButton.click(function (e) {
        _this5.form.sender_fullname = $('#sender_fullname_input').val();
        _this5.form.sender_email = $('#sender_email_input').val();
        _this5.form.privacy = $('#privacy_checkbox').is(":checked");
        e.preventDefault();

        if (_this5.form.sender_fullname !== '' && _this5.form.sender_email !== '' && _this5.form.privacy !== false) {
          if (_this5.validateEmail(_this5.form.sender_email)) {
            e.preventDefault();
            _this5.error = '';

            _this5.systemMessage.removeClass('active');

            _this5.systemMessage.find('p').removeClass('error').text(_this5.error);

            _this5.form.country = window.location.href.slice(-2);
            /* Ajax */

            $.ajax({
              method: "POST",
              url: _this5.API_URL,
              data: JSON.stringify(_this5.form),
              contentType: 'application/json; charset=utf-8',
              success: function success(data) {
                console.log(data);
                data = JSON.parse(data);

                if (data.success !== "OK") {
                  console.log('error');
                } else {
                  $("#resultStep form").hide();
                  $('#step4PrevButton').hide();
                  $("#resultStep .result").show();
                }
              },
              error: function error(jqXHR, textStatus, errorThrown) {
                $("#result").slideDown();
              }
            });
          } else {
            _this5.scrollToTop('section.upload');

            _this5.error = 'Zadaný e-mail nemá správný formát!';

            _this5.systemMessage.addClass('active');

            _this5.systemMessage.find('p').addClass('error').text(_this5.error);
          }
        } else {
          e.preventDefault();

          _this5.scrollToTop('section.upload');

          _this5.error = 'Nebyla vyplněna všechna pole!';

          _this5.systemMessage.addClass('active');

          _this5.systemMessage.find('p').addClass('error').text(_this5.error);
        }
      });
      /* Prev buttons */

      this.step4PrevButton.find('input').click(function () {
        _this5.error = '';

        _this5.systemMessage.removeClass('active');

        _this5.systemMessage.find('p').removeClass('error').text(_this5.error);

        handler(5);
      });
    }
  }, {
    key: "uploadImage",
    value: function uploadImage() {
      var uploadZone = $('canvas');
      var uploadButton = $('input[type=file]');
      uploadZone.click(function () {
        uploadButton.trigger('click');
      });
    }
  }, {
    key: "cropImage",
    value: function cropImage() {
      var _this = this;

      var uploadInfoImage = $('.canvas-container img.upload-image');
      var canvas = $("#canvas"),
          context = canvas.get(0).getContext("2d"),
          $result = $('#result');
      $('input[type=file]').on('change', function () {
        if (this.files && this.files[0]) {
          if (this.files[0].type.match(/^image\//)) {
            if (this.files[0].size / 1000 <= _this.MAX_FILE_SIZE) {
              var reader = new FileReader();
              _this.form.imageName = this.files[0].name;

              reader.onload = function (evt) {
                var img = new Image();
                uploadInfoImage.hide();
                img.src = evt.target.result;

                img.onload = function () {
                  if (img.width >= _this.MIN_IMAGE_WIDTH && img.height >= _this.MIN_IMAGE_HEIGHT) {
                    if (img.width <= _this.MAX_IMAGE_WIDTH && img.height <= _this.MAX_IMAGE_HEIGHT) {
                      context.canvas.height = img.height;
                      context.canvas.width = img.width;
                      context.drawImage(img, 0, 0);
                      var cropper = canvas.cropper();
                      $('#btnCrop').click(function () {
                        var croppedImageDataURL = canvas.cropper('getCroppedCanvas').toDataURL("image/png");
                        $result.html($('<img>').attr('src', croppedImageDataURL));
                        _this.form.croppedImage = croppedImageDataURL;
                      });

                      _this.photoStep2Button.fadeIn(300);
                    } else {
                      alert('Obrázek má příliš veliké rozměry! Max: 6000x6000px');
                    }
                  } else {
                    alert('Obrázek má příliš malé rozměry! Min: 1300x1300px');
                  }
                };
              };

              reader.readAsDataURL(this.files[0]);
            } else {
              alert("Obrázek je moc veliký! Max: 8MB.");
            }
          } else {
            alert("Nesprávný formát obrázku!");
          }
        } else {
          alert('Nebyl vybrán žádný obrázek.');
        }
      });
    }
  }]);

  return HomepageController;
}();